import api from '../config/api';
import { ApiResponse } from '../types';

export interface ContactFormData {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  category: string;
  title: string;
  message: string;
}

export const contactService = {
  getCategories: async (): Promise<ApiResponse<{ categories: string[] }>> => {
    const response = await api.get('/contact/categories');
    return response.data;
  },

  submitContactForm: async (data: ContactFormData): Promise<ApiResponse> => {
    const response = await api.post('/contact', data);
    return response.data;
  },
};
